import { mapGetters } from 'vuex'
import { some, isEmpty } from 'lodash-es'
import AttributeListingFiltersModel from '../Models/AttributeListingFiltersModel'

export default {
  data: () => {
    return {
      attributeListingFiltersModel: null
    }
  },
  created () {
    const duplicateAttributeGroupNamesPerGroup = this.getAttributeMergeDuplicateValuesByName ? this.getDuplicateAttributeGroupNamesPerGroup : {}
    this.attributeListingFiltersModel = new AttributeListingFiltersModel(
      this.getUriWithoutOffset,
      this.getAttributeFilterQueryStringVar,
      this.getActiveAttributeFilters,
      this.getIsTopLevelCategory,
      this.getCurrentPageNumber,
      this.config.url.lang,
      this.activeFiltersString,
      duplicateAttributeGroupNamesPerGroup
    )
  },
  computed: {
    ...mapGetters([
      'getAttributeFilterQueryStringVar',
      'getActiveAttributeFilters',
      'getAttributeRecordsUsed',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'config',
      'getDuplicateAttributeGroupNamesPerGroup',
      'getAttributeMergeDuplicateValuesByName',
      'getActiveTagFiltersString'
    ]),
    activeFiltersString () {
      const tagFiltersString = this.getActiveTagFiltersString
      const variationFiltersString = this.getActiveVariationFiltersString
      if (tagFiltersString !== '' && variationFiltersString !== '') {
        return tagFiltersString + '&' + variationFiltersString
      }
      if (tagFiltersString !== '') {
        return tagFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringLocationManage (group, entry) {
      window.location.assign(this.filteringManage(group, entry))
    },
    filteringManage (group, entry) {
      const isFilterUsed = this.isFilterUsed(group, entry)
      return this.attributeListingFiltersModel.createLinkQueryStringFinal(group, entry, isFilterUsed)
    },
    checkIfAllAttributeValueIdsAreUsed (group, entry) {
      const entryIds = entry.chunkValueIds
      if (!isEmpty(this.getAttributeRecordsUsed[group.attributeGroupId])) {
        const attributeRecordKeysUsed = Object.keys(this.getAttributeRecordsUsed[group.attributeGroupId]).map(Number)
        return entryIds.map(
          (key) => {
            return attributeRecordKeysUsed.includes(key)
          }
        ).every(element => element === true)
      }
      return false
    },
    isFilterUsed (group, entry) {
      if (this.isTextRangeGroup(group)) {
        return this.checkIfAllAttributeValueIdsAreUsed(group, entry)
      } else {
        return some(this.getAttributeRecordsUsed[group.attributeGroupId], { attributeId: entry.attributeId })
      }
    },
    isTextRangeGroup (group) {
      return this.attributeListingFiltersModel.isTextRangeGroup(group)
    },
    entryDisplayValue (group, entry, { trim = false, trimLength = 30 } = {}) {
      if (this.isTextRangeGroup(group)) {
        return entry.chunkName
      }
      if (group.attributeDisplayType === 'image' || group.attributeDisplayType === 'hex-color') {
        return entry.attributeDisplayValue
      }
      if (trim) {
        return entry.attributeName.length > trimLength ? entry.attributeName.substring(0, trimLength) + '...' : entry.attributeName
      }
      return entry.attributeName
    }
  }
}
